export default __webpack_public_path__ + "static/media/chevronDown.bdfc5d51.svg";